export default __webpack_public_path__ + "static/media/en azul-01.09c5791b.svg";